<template lang='pug'>
//- aidoctor-Page
div(:class='$style[`cc-aidoctor`]')
  div(:class='$style[`cc-aidoctor-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        //- figure.graphic.graphic-result(:class='$style[`cc-graphic-result`]')
        //-   img(:src='`${STATIC_URL}images/vip/p0.webp`' width='100%')
        span.no-wrap QA
        span.font-doctor-theme 問
        span.font-normal-theme 答
        span.no-wrap 庫

      //- div(:class='$style[`cc-banner-sub-title`]')
      //-   span.font-medium 請輸入症狀或問題並選擇相似的提問，立即看解答。

    div(:class='$style[`cc-aidoctor-searchbar`]')
      div(:class='$style[`cc-aidoctor-searchbar-wrap`]')
        Inputer(
          v-model='aiDoctorValue'
          title='簡述您的問題與病症'
          style='width: 100%'
          :key='`input-${infiniteId}`'
          :class='$style[`cc-aidoctor-searcher`]'
          :resetButton='false'
          :defaultValue='aiDoctorValue'
          :placehold='`輸入關鍵字，選擇相似的提問`'
          :keyPressEnter='handleInputSearch'
          :errorRegex='aiDoctorError'
          :errorRegexInfo='aiDoctorErrorLog'
          :errorValue='aiDoctorError'
          @clearErrorMsg="(value) => {this.aiDoctorError = value[0]; this.aiDoctorErrorLog = '';}")

        button(
          tabindex='0'
          aria-label='搜尋'
          :class='$style[`cc-aidoctor-searchbar-btn`]'
          title='搜尋'
          @click='handleInputSearch')
          IconSearch(:size='24' :color='`#98a1a1`')

    div(v-if='showLoading' :class='$style[`cc-aidoctor-container`]')
      div(:class='$style[`cc-aidoctor-container-wrap`]')
        IconLoading(:size='36' :color='`#b1b1b1`')

    div(v-else :class='$style[`cc-aidoctor-container`]')
      //- 熱門QA
      div(:class='$style[`cc-aidoctor-popular`]')
        header(:class='$style[`cc-aidoctor-popular-title`]')
          span.font-bold(:class='$style[`cc-aidoctor-popular-maintitle`]') 熱門搜尋
        ul(:class='$style[`cc-aidoctor-popular-ul`]')
          li(v-for='items, index in popularResult' :key='index' :class='$style[`cc-aidoctor-popular-li`]')
            button(
              tabindex='0'
              :aria-label='`選擇${items.content}`'
              :title='`選擇${items.content}`'
              :class='$style[`cc-aidoctor-popular-btn`]'
              @click='handleClickPopularBtn(items.content)') {{ items.content }}

      div(v-if='aidoctorActive' :class='$style[`cc-aidoctor-container-wrap`]')
        //- Ai 智能醫生
        div(:class='$style[`cc-aidoctor-container-wrap-aidoctor`]')
          header(:class='$style[`cc-aidoctor-container-wrap-aidoctor-title`]')
            //- div.border-gradient(:class='$style[`cc-aidoctor-container-wrap-aidoctor-tips`]') VIP會員限定
            span.font-bold(:class='$style[`cc-aidoctor-container-wrap-aidoctor-maintitle`]') 選擇相似症狀
            span.font-regular(:class='$style[`cc-aidoctor-container-wrap-aidoctor-subtitle`]') 解答由「癌康網團隊」提供

          div(:class='$style[`cc-aidoctor-container-wrap-aidoctor-container`]')
            AiSolution(
              :key='`ais-${infiniteId}`'
              :isVip='subscribeVip === `yes` ? true : false'
              :searchValue='aiDoctorValue'
              :redirectRouter='`ai-doctor`'
              :bpDesktop='4')

      //- 抗癌金句
      div(v-else :class='$style[`cc-aidoctor-knowledge`]')
        div(:class='$style[`cc-aidoctor-knowledge-title`]')
          IconIdeas(:size='36')
          span.font-bold 抗癌金句
          //- span.font-bold.font-doctor-theme.no-wrap 金
          //- span.font-bold.font-normal-theme.no-wrap 句

        div(:class='$style[`cc-knowledge-wrap`]')
          div(v-if='randomContent' :class='$style[`cc-knowledge-wrap-block`]')
            span.font-medium(:class='$style[`cc-knowledge-wrap-block-title`]') {{ randomContent.content }}
          div(v-else :class='$style[`cc-knowledge-wrap-block`]')
            IconLoading(:size='30' :color='`#b1b1b1`')

          div(:class='$style[`cc-content-knowledge-controller`]')
            //- button.btn-extra.font-medium(
            //-   aria-label='關閉'
            //-   tabindex='0'
            //-   :class='$style[`cc-knowledge-controller-btn`]'
            //-   @click='handleClickToClose') 關閉

            button.btn-extra.font-medium(
              aria-label='下一個'
              tabindex='0'
              :class='$style[`cc-knowledge-controller-btn`]'
              @click='handleClickShowNext') 看下一個



</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import { directive } from 'vue-awesome-swiper';
import {
  putAiDoctorPopular,
  putLoadGoldKnowLedge
} from '../../../js/restapi';

import IconLoading from '../../icon/Loading';
import IconConfirm from '../../icon/Confirm';
import IconDelete from '../../icon/Delete';
import IconSearch from '../../icon/Search';
import IconIdeas from '../../icon/Ideas.vue';
import Inputer from '../common/Input';
import AiSolution from '../ai/AiSolution';

export default {
  metaInfo() {
    return {
      title: 'QA問答庫',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/aidoctor`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/search/aidoctor`,
      }],
    };
  },

  directives: {
    swiper: directive,
  },

  components: {
    IconLoading,
    IconConfirm,
    IconDelete,
    IconSearch,
    IconIdeas,
    Inputer,
    AiSolution,
  },

  data() {
    return {
      aiDoctorValue: this.$route.query.q || '',
      aiDoctorError: false,
      aiDoctorErrorLog: '不能為空白',
      // splitKeyword: '',
      // isCancellEmpty: false,
      // isVip: false,
      showLoading: true,
      aidoctorActive: false,
      popularResult: [],
      goldData: [],
      goldDataCount: 0,
      // basicResult: {},
      infiniteId: 1,
      nextTick: 1,
    };
  },

  created() {
    this.initPageOnLoad();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    initPageOnLoad() {
      this.axiosLoadPopularSearchAndGoldKnowledge();

      if (!this.$route.query.q) {
        this.$router.replace({
          name: 'ai-doctor',
        }).catch(()=>{});
      } else {
        if (!this.loginStatus) {
          this.changePopBoxStatus({
            active: true,
            include: 'login',
          });
          return;
        }
        this.handleAiDoctorSearchBar(this.$route.query.q);
      }
    },

    handleClickShowNext() {
      this.nextTick += 1;
    },

    handleInputSearch() {
      this.aidoctorActive = false;

      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }

      this.handleAiDoctorSearchBar(this.aiDoctorValue);
    },

    handleAiDoctorSearchBar(query) {
      this.aiDoctorValue = query;

      if (!this.aiDoctorValue) {
        this.aiDoctorError = true;
        this.aiDoctorErrorLog = '不能為空白';
        return;
      }

      this.$router.push({
        name: 'ai-doctor',
        query: {
          q: this.aiDoctorValue
        },
      }).catch(() => true);

      this.aidoctorActive = true;
    },

    handleClickPopularBtn(query) {
      this.aiDoctorError = false;
      this.aidoctorActive = false;

      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }

      if (query) {
        this.aiDoctorValue = query;
      }
      this.handleAiDoctorSearchBar(this.aiDoctorValue);
    },

    axiosLoadPopularSearchAndGoldKnowledge() {
      // putAiDoctorPopular('', {}, {
      //   headers: {
      //     'content-Type': 'application/json',
      //     // Authorization: `Bearer ${jwtAccess}`,
      //   },
      // })
      //   .then((res) => {
      //     this.popularResult = res.data;
      //     this.showLoading = false;
      //   })
      //   .catch((err) => {
      //     console.log('err', err);
      //   });

      axios.all([
        putAiDoctorPopular(''),
        putLoadGoldKnowLedge('', {
          page: '1',
          size: '200',
          search: ''
        })])
        .then(axios.spread((popularData, goldData) => {
          this.popularResult = popularData.data;
          this.goldData = goldData.data.results;
          this.goldDataCount = goldData.data.count;
          this.showLoading = false;
        }))
        .catch((err) => {
          console.log('err', err.response);
        })
    },

    // axiosLoadPopularSearch() {
    //   putAiDoctorPopular('', {}, {
    //     headers: {
    //       'content-Type': 'application/json',
    //       // Authorization: `Bearer ${jwtAccess}`,
    //     },
    //   })
    //     .then((res) => {
    //       this.popularResult = res.data;
    //       this.showLoading = false;
    //     })
    //     .catch((err) => {
    //       console.log('err', err);
    //     });
    // },
  },

  computed: {
    ...mapGetters({
      loginStatus: 'user/exportLoginStatus',
      subscribeVip: 'user/exportUserSubscribeVip',
    }),

    randomContent() {
      this.nextTick;
      const index = Math.floor(Math.random() * (this.goldDataCount))
      const getContent = this.goldData[index];
      return getContent;
    }
  },

  watch: {
    loginStatus() {
      if (this.loginStatus) {
        // alert('已登入！！');
        this.initPageOnLoad();
      }
    },

    // aiDoctorValue() {
    //   this.initPageOnLoad();
    // },

    $route(to, from) {    
      console.log('route', this.$route);
      if (this.$route.query.q) {
        this.infiniteId += 1;
      }
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/search/aiDoctor.scss';
</style>
